import * as z from "zod";

export const disconnectPayPalIntegration = {
  name: "disconnectPayPalIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
